import { render, staticRenderFns } from "./CheckoutStep.vue?vue&type=template&id=125013c6&scoped=true&"
import script from "./CheckoutStep.vue?vue&type=script&lang=js&"
export * from "./CheckoutStep.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutStep.vue?vue&type=style&index=0&id=125013c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125013c6",
  null
  
)

export default component.exports